// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__cqEAW","footer":"Footer_footer__kXlYa","footerText":"Footer_footerText__rlW5Y"};